export default {"src":"/_next/static/image/src/images/CheckoutConfirmation/ollie-box.46573c0d67358a97908e6144bdd80cbc.svg","height":82,"width":115};